import { promptExpand } from "@/api/common";
import TextArea from "@/components/TextArea";
import { Toast } from "@/components/Toast";
import {
  setAdvancePrompt,
  setPromptExpanding,
  setTxt2ImgTexts,
  statusStore,
} from "@/stores/status";
import { draftStore } from "@/thirdParty/draft/store";
import { monkeyStore } from "@/thirdParty/monkey/store";
import events, { MessageType } from "@/utils/events";
import { Editor_Words } from "@/utils/lang/editor";
import { sensitiveWordCheck } from "@/utils/string";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useBoolean,
} from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

function PromptExpandModal() {
  const [isOpen, stateOp] = useBoolean(false);
  const [text, setText] = useState("");
  const { tgt } = langStore;
  const { mode, modelType } = statusStore;
  useEffect(() => {
    events.on(MessageType.PROMPT_EXPAND, stateOp.on);
    return () => {
      events.off(MessageType.PROMPT_EXPAND);
    };
  }, []);

  const handleConfirm = async () => {
    const checkRes = text
      ? await sensitiveWordCheck(text).catch((e) => {
          return e;
        })
      : true;
    if (!checkRes) {
      Toast({
        title: translate(Editor_Words["get-prompt-not-safe-warning-message"], tgt),
        status: "warning",
      });
      return;
    }
    setPromptExpanding(true);
    monkeyStore.setPromptExpanding(true);
    draftStore.setPromptExpanding(true);
    stateOp.off();
    const res = await promptExpand(text).catch(() => {
      setPromptExpanding(false);
      monkeyStore.setPromptExpanding(false);
      draftStore.setPromptExpanding(false);
      setText("");
      return null;
    });
    if (res?.code === 0) {
      if (modelType === "draft") {
        draftStore.setText(res.data.text);
      } else if (modelType === "monkey") {
        monkeyStore.setPrompt(res.data.text);
      } else if (modelType === "wenxin") {
        setTxt2ImgTexts(res.data.text);
      } else {
        if (mode === "advance") {
          setAdvancePrompt(res.data.text);
        } else {
          setTxt2ImgTexts(res.data.text);
        }
      }
    }
    setPromptExpanding(false);
    monkeyStore.setPromptExpanding(false);
    draftStore.setPromptExpanding(false);
    setText("");
  };

  return (
    <Modal isOpen={isOpen} onClose={stateOp.off} isCentered>
      <ModalOverlay />
      <ModalContent bg="#323232" w="605px" p="0">
        <ModalHeader color="#B3B3B3">
          {translate(Editor_Words["prompt-expand-modal-title"], tgt)}
        </ModalHeader>
        <ModalCloseButton color="#858585" />
        <ModalBody textAlign="center">
          <TextArea
            w="536px"
            mt="0"
            textAreaH={256}
            text={text}
            setText={setText}
            placeholderWord={translate(Editor_Words["prompt-expand-placeholder"], tgt)}
            lang={tgt}
          ></TextArea>
          <Button
            variant="primary"
            w="280px"
            h="48px"
            my="24px"
            fontSize="20px"
            onClick={handleConfirm}
          >
            {translate(Editor_Words["prompt-expand"], tgt)}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default observer(PromptExpandModal);
